import script from "./product-category.vue?vue&type=script&setup=true&lang=js"
export * from "./product-category.vue?vue&type=script&setup=true&lang=js"

import "./product-category.vue?vue&type=style&index=0&id=64951905&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64951905"]])

export default __exports__